<template>
  <v-layout style="position: relative; overflow-y: auto;"
  :style="{height: isMobile ? mobileHeight : 'calc(100vh - 68px)'}"
    :class="{ hiddenScroll: !isMobile }">
    <v-navigation-drawer v-model="drawer" :rail="computedRail" permanent style="position: fixed" class="navDrawer"
      :class="{ 'pt-0': isMobile, 'rounded-lg': isMobile }" :style="{
        border: isMobile ? '2px solid rgb(var(--v-theme-background)) !important' : '',
      }">
      <v-container fluid :class="{ 'pl-4': !computedRail, 'pl-0': computedRail }" class="pr-3">
        <v-row @click.stop="rail = !rail" v-if="!isMobile">
          <v-col cols="auto">
            <v-card style="background-color: transparent" class="pa-2" flat>
              <div style="display: flex; align-items: center">
                <v-icon class="mr-4" style="margin-top: 2px; color: darkgray">mdi-menu</v-icon>
                <b>{{ $t("basics.menu") }}</b>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" style="display: flex; align-items: center">
            <p>{{ $t("basics.hello") }}, {{ username }}!</p>
          </v-col>
        </v-row>
        <hr class="my-4" style="opacity: 0.3" />

        <div v-for="(r, index) in routeArray">
          <v-row class="mt-3" v-if="!r.props.permission || $store.state.permission == r.props.permission">
            <v-col v-if="
              r &&
              routeAvailableForUser(r) &&
              (r.props.displayInNavigation ||
                (r.props.displayOnActive && isActive(r))) &&
              !(r.props.hideOnActive && activeRoute.startsWith(r.props.hideOnActive))
            " :class="{ 'pb-0': computedRail }" :style="{
              'background-color':
                r.name == activeRoute || activeRoute.startsWith(r.name)
                  ? 'rgba(var(--v-theme-primary), 0.1)'
                  : '',
            }">
              <v-card class="pa-2" flat :style="{
                'background-color': computedRail
                  ? 'transparent'
                  : r.name == activeRoute || activeRoute.startsWith(r.name)
                    ? 'rgba(var(--v-theme-primary), 0.2)'
                    : 'rgb(var(--v-theme-light))',
              }" @click="gotoRoute(r)" @mousedown.middle="openRouteInNewTab($event, r)">
                <v-tooltip :text="r.props?.info" v-model="showTooltips[index]">
                  <template v-slot:activator="{ props }">
                    <div style="display: flex; align-items: center">
                      <v-tooltip :text="$t('routes.' + r.name)" v-if="rail">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" class="mr-4" :style="{
                            color: isActive(r)
                              ? 'rgb(var(--v-theme-primary))'
                              : 'darkgray',
                          }" style="margin-top: 2px" :size="'large'">mdi-{{ r.props.icon }}</v-icon>
                        </template>
                      </v-tooltip>

                      <v-icon v-else class="mr-4" :style="{
                        color: isActive(r) ? 'rgb(var(--v-theme-primary))' : 'darkgray',
                      }" style="margin-top: 2px" :size="'large'">mdi-{{ r.props.icon }}</v-icon>

                      <span v-if="isActive(r)">
                        <b><span v-if="r.props.displayName">
                            {{ $t("routes." + r.props.displayName) }}</span>
                          <span v-else> {{ $t("routes." + r.name) }}</span>
                        </b>
                      </span>
                      <span v-else>
                        <p>
                          <span v-if="r.props.displayName">
                            {{ $t("routes." + r.props.displayName) }}</span>
                          <span v-else> {{ $t("routes." + r.name) }}</span>
                        </p>
                      </span>
                    </div>
                  </template>
                </v-tooltip>
              </v-card>
              <v-expand-transition v-if="showChildren(r)">


                <div v-show="computedRail ||
                  isMobile ||
                  r.props.stayActive ||
                  (isActive(r) && r.children && r.children.length > 1)
                  ">
                  <v-container v-if="showChildren(r)">
                    <v-row @click="gotoChild(c)" @mousedown.middle="openChildInNewTab($event, c)"
                      v-for="(c, cIndex) in r.children" style="cursor: pointer">
                      <v-tooltip :text="c.props?.info" v-model="showChildTooltips[index * routeArray.length + cIndex]">
                        <template v-slot:activator="{ props }">
                          <v-col v-if="routeAvailableForUser(c) && c.props.displayInNavigation"
                            :class="{ 'pa-0': computedRail }">
                            <v-card class="pa-2" :class="{ 'pr-0': computedRail, 'pl-1': computedRail }" flat :style="{
                              'background-color': computedRail
                                ? 'transparent'
                                : c.name == activeRoute ||
                                  activeRoute.startsWith(c.name)
                                  ? 'rgba(var(--v-theme-primary), 0.2)'
                                  : 'rgb(var(--v-theme-light))',
                            }">
                              <div style="display: flex; align-items: center" :style="{
                                'justify-content': computedRail
                                  ? 'center'
                                  : 'flex-start',
                              }">
                                <v-tooltip :text="$t(
                                  'routes.' +
                                  (c.props && c.props.displayName
                                    ? c.props.displayName
                                    : c.path)
                                )
                                  " v-if="computedRail">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" class="mx-0" :size="computedRail ? 'small' : 'large'" :style="{
                                      color:
                                        c.name == activeRoute ||
                                          activeRoute.startsWith(c.name)
                                          ? 'rgb(var(--v-theme-primary))'
                                          : 'darkgray',
                                    }" style="margin-top: 2px">mdi-{{ c.props.icon }}</v-icon>
                                  </template>
                                </v-tooltip>

                                <v-icon v-else class="mr-2" :size="computedRail ? 'small' : 'large'" :style="{
                                  color:
                                    c.name == activeRoute ||
                                      activeRoute.startsWith(c.name)
                                      ? 'rgb(var(--v-theme-primary))'
                                      : 'darkgray',
                                }" style="margin-top: 2px">mdi-{{ c.props.icon }}</v-icon>

                                <b v-if="
                                  !computedRail &&
                                  (c.name == activeRoute ||
                                    activeRoute.startsWith(c.name))
                                ">{{
                                  $t(
                                    "routes." +
                                    (c.props && c.props.displayName
                                      ? c.props.displayName
                                      : c.path)
                                  )
                                }}</b>
                                <p v-else-if="!computedRail">
                                  {{
                                    $t(
                                      "routes." +
                                      (c.props && c.props.displayName
                                        ? c.props.displayName
                                        : c.path)
                                    )
                                  }}
                                </p>
                              </div>
                            </v-card>
                          </v-col>
                        </template>
                      </v-tooltip>
                    </v-row>
                  </v-container>
                </div>
              </v-expand-transition>

              <v-divider class="mt-1" v-if="computedRail && index != routeArray.length - 1" />
            </v-col>
          </v-row>
        </div>
        
        <v-row style="flex-grow: 0" v-if="isMobile">
          <v-spacer />
          <v-col cols="auto" style="display: flex; align-items: center">
            <v-tooltip :text="$t('basics.logout')">
              <template v-slot:activator="{ props }">
                <p class="hoverable" v-bind="props" @click="logout()">
                  <b><v-icon>mdi-logout</v-icon> {{ $t("basics.logout") }}</b>
                </p>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="availRoutes && availRoutes.length > 0" fluid>
        <v-divider class="mb-4" />
        <v-row v-for="ar in availRoutes" @click="gotoAvailRoutes(ar)"
          @mousedown.middle="gotoAvailRoutesInNewTab($event, ar)">
          <v-col class="hoverable" v-if="!rail">
            {{ $t("basics.goto", { type: $t("routes." + ar) }) }}
          </v-col>
          <v-col class="hoverable pl-0" v-else style="">
            <v-icon style="margin-top: 2px" class="mr-1">mdi-arrow-left</v-icon><small>{{ $t("routes.short_" + ar)
            }}</small>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-main style="height: 250px"></v-main>
  </v-layout>
</template>

<script>
import { routes } from "../../router/index.js";

export default {
  name: "navigationDrawer",

  data() {
    return {
      drawer: true,
      rail: true,

      routeArray: undefined,
      availRoutes: undefined,

      showTooltips: [],
      showChildTooltips: [],
    };
  },

  computed: {
    username() {
      return this.$store.state.name;
    },
    computedRail() {
      return !this.isMobile && this.rail;
    },
    isAdmin() {
      return this.$store.state.permission == "admin";
    },
    mobileHeight(){
      if(!this.routeArray){
        return "calc(100vh - 60px)"
      }

      let temp = this.routeArray.length
      let temp2 = this.availRoutes.length

      let result = (temp*70 + temp2*70 + 150)

      if(result > (window.innerHeight * 0.9)){
        result = window.innerHeight * 0.9
      }

      return result + "px"
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },

    activeRoute() {
      return this.$route.name;
    },
    subMenuObject() {
      if (
        this.$route.matched[this.$route.matched.length - 2] &&
        this.$route.matched[this.$route.matched.length - 2].props.default.switchMenu
      ) {
        return this.$route.matched[this.$route.matched.length - 2];
      }

      return undefined;
    },
    getRouteTypeParam() {
      return this.$route.params.type;
    },
    routeName() {
      return this.$route.matched[0].name;
    },
  },

  watch: {
    rail() {
      this.$store.dispatch("setCollapseNavBar", this.rail ? 1 : 0);
    },
    "$vuetify.display.name"() {
      if (this.isMobile) {
        this.rail = true;
      }
    },
  },

  methods: {
    routeAvailableForUser(r) {
      let permForRoute = this.$checkRouterPermission("GET", r);

      let permForChild = false;

      if (r.children) {
        for (let i = 0; i < r.children.length; i++) {
          if (this.$checkRouterPermission("GET", r.children[i])) {
            permForChild = true;
            break;
          }
        }
      } else {
        permForChild = true;
      }
      return permForRoute && permForChild;
    },
    isActive(route) {
      return route.name == this.activeRoute || this.activeRoute.startsWith(route.name);
    },
    showChildren(routeObject) {
      let count = 0;
      if (routeObject.children && routeObject.children.length > 0) {
        for (let i = 0; i < routeObject.children.length; i++) {
          if (
            routeObject.children[i].props &&
            routeObject.children[i].props.displayInNavigation
          ) {
            if (
              !routeObject.children[i].props.routerPermission ||
              this.$checkFunctionPermission(
                routeObject.children[i].props.routerPermission
              )
            ) {
              count += 1;
            }
          }
        }
      }

      if (count > 1) {
        return true;
      }

      return false;
    },
    calculateRoute(routeObject) {
      if (routeObject.props.parentMenu) {
        return "/" + this.routeName + "/" + routeObject.props.parentMenu;
      } else if (routeObject.props.rerouteToChild && routeObject.children) {
        for (let i = 0; i < routeObject.children.length; i++) {
          if (routeObject.children[i].props.displayInNavigation) {
            if (
              !routeObject.children[i].props.routerPermission ||
              this.$checkFunctionPermission(
                routeObject.children[i].props.routerPermission
              )
            ) {
              return (
                "/" +
                this.routeName +
                "/" +
                routeObject.path +
                "/" +
                routeObject.children[i].path
              );
            }
          }
        }
      } else {
        return "/" + this.routeName + "/" + routeObject.path;
      }
    },
    gotoRoute(routeObject) {
      this.$forceUpdate();

      for (let i = 0; i < this.showTooltips.length; i++) {
        this.showTooltips[i] = false;
      }
      for (let i = 0; i < this.showChildTooltips.length; i++) {
        this.showChildTooltips[i] = false;
      }

      window.dispatchEvent(new CustomEvent("closeNavMenu"));
      this.$router.push(this.calculateRoute(routeObject));
    },
    openRouteInNewTab(event, routeObject) {
      window.dispatchEvent(new CustomEvent("closeNavMenu"));

      for (let i = 0; i < this.showTooltips.length; i++) {
        this.showTooltips[i] = false;
      }
      for (let i = 0; i < this.showChildTooltips.length; i++) {
        this.showChildTooltips[i] = false;
      }

      event.stopPropagation();
      event.preventDefault();

      window.open(this.calculateRoute(routeObject), "_blank");
    },
    getChildPath(routeObject) {
      let path = this.$router.resolve({
        name: routeObject.name,
      });

      return path.fullPath;
    },
    gotoChild(routeObject) {
      window.dispatchEvent(new CustomEvent("closeNavMenu"));

      this.$router.push(this.getChildPath(routeObject));
    },
    openChildInNewTab(event, routeObject) {
      event.stopPropagation();
      event.preventDefault();

      window.open(this.getChildPath(routeObject), "_blank");
    },
    gotoParent() {
      window.dispatchEvent(new CustomEvent("closeNavMenu"));

      this.$router.push(
        "/" + this.routeName + "/" + this.subMenuObject.props.default.parentMenu
      );
    },
    gotoAvailRoutesInNewTab(event, ar) {
      window.dispatchEvent(new CustomEvent("closeNavMenu"));

      event.stopPropagation();
      event.preventDefault();

      window.open("/" + ar + "/dashboard/");
    },
    gotoAvailRoutes(ar) {
      window.dispatchEvent(new CustomEvent("closeNavMenu"));

      this.$router.push("/" + ar + "/dashboard/");
      setTimeout(() => {
        window.location.reload();
      }, 100);
    },
    
    logout() {
      this.$store.dispatch("logoutUser").catch((e) => {
        window.location.reload();
      });
    },
  },

  mounted() {
    this.rail =
      this.$store.state.collapseNavBar && parseInt(this.$store.state.collapseNavBar)
        ? true
        : false;

    if (this.isMobile) {
      this.rail = true;
    }

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].name == this.routeName) {
        this.routeArray = routes[i].children;
        break;
      }
    }

    let temp = this.$store.state.avail_routes.split(",");
    this.availRoutes = [];
    for (let i = 0; i < temp.length; i++) {
      if (temp[i] != this.routeName) {
        this.availRoutes.push(temp[i]);
      }
    }

    window.addEventListener("refreshNav", (value) => {
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].name == this.routeName) {
          this.routeArray = routes[i].children;
          break;
        }
      }

      let temp = this.$store.state.avail_routes.split(",");
      this.availRoutes = [];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i] != this.routeName) {
          this.availRoutes.push(temp[i]);
        }
      }

      this.$forceUpdate();
    });
  },
};
</script>
